import Joi from 'joi';
import type { ISnapshotMeta } from './snapshotMeta';
import { snapshotMetaSchemaMap } from './snapshotMeta';
import { actionCreator, objectSchemaOf } from '../helpers';
import { forConversation } from '../channels';

export const SNAPSHOT_AVAILABLE = 'VISION/SNAPSHOT_AVAILABLE';

interface ISnapshotAvailableActionPayload extends ISnapshotMeta {
  conversationId: string;
  name: string;
  url: string;
}

export type ISnapshot = ISnapshotAvailableActionPayload;

const snapshotAvailableActionPayloadSchema = objectSchemaOf<ISnapshotAvailableActionPayload>(
  {
    ...snapshotMetaSchemaMap,
    conversationId: Joi.string().required(),
    name: Joi.string().required(),
    url: Joi.string().required(),
  }
);

export const snapshotAvailableActionSchema = objectSchemaOf<ISnapshotAvailableAction>(
  {
    type: Joi.string().required().valid(SNAPSHOT_AVAILABLE),
    payload: snapshotAvailableActionPayloadSchema.required(),
  }
);

export interface ISnapshotAvailableAction {
  type: typeof SNAPSHOT_AVAILABLE;
  payload: ISnapshotAvailableActionPayload;
}

export const snapshotAvailable = actionCreator({
  type: SNAPSHOT_AVAILABLE,
  schema: snapshotAvailableActionSchema,
  channels: [forConversation],
});
